module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cHKsZ"))).then(() => parcelRequire('1iHdE'));